/* eslint-disable import/no-cycle */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { React } from "react";
import "./ConfirmationPrompt.css";
import create from "zustand";
import { AR_SM_CONST } from "../machines/ARSM";
import Event from "../modules/Event";

const store = (set) => ({
  show: false,
  setShow: (show) => set({ show }),
  checkContinue: false,
  setCheckContinue: (checkContinue) => set({ checkContinue }),
});

export const ConfirmationPromptStore = create(store);

function ConfirmationPrompt() {
  const show = ConfirmationPromptStore((s) => s.show);
  const setShow = ConfirmationPromptStore((s) => s.setShow);
  if (show) {
    return (
      <div className="ConfirmationPrompt">
        <div className="prompt-box">
          <div className="prompt-text">
            Are you sure you want to delete and reposition the model?
          </div>
          <div
            className="continue-button"
            onClick={() => {
              setShow(false);
              Event.sendSMEvent(AR_SM_CONST.RECENTER_READY);
            }}
          >
            Continue
          </div>
          <div
            className="cancel-button"
            onClick={() => {
              setShow(false);
            }}
          >
            Cancel
          </div>
        </div>
      </div>
    );
  }
  return null;
}

export default ConfirmationPrompt;
